import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Popconfirm } from 'tdesign-react';

import { LibraryDelete, LibraryEdit } from '@/components/icon';
import { RenameType } from '@/interface/library';
import { CgiErrorCode } from '@/services/cgi';
import { useAppDispatch, useTypedSelector } from '@/store';
import { changeId } from '@/store/modules/library';

import Rename from '../../list/rename';
import styles from './index.module.less';

const LeftPanelItem: React.FC<{
  disabled: boolean;
  active: boolean;
  item: {
    id: string;
    name: string;
    disableOperate: boolean;
    keyIndex: string;
  };
  reNameCallback: (code: CgiErrorCode, info: {
    name: string;
    id: string;
  }, item: {
      id: string;
      name: string;
      disableOperate: boolean;
      keyIndex: string;
    }) => void;
  handleOpenEdit: (id: string) => void
  confirmDelete: (id: string) => Promise<void>;
  handleChangeSearchValue: (e: React.MouseEvent, id: string, clear?: boolean) => void;
}> = (({ disabled, item, active, reNameCallback, confirmDelete, handleChangeSearchValue }) => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);
  const [changed, setChanged] = useState(false);

  const libraryStore = useTypedSelector(store => store.library);

  useEffect(() => {
    setVisible(libraryStore?.id === item.id);
  }, [item.id, libraryStore?.id, changed]);

  const changeVisible = (vi: boolean) => {
    if (vi) {
      dispatch(changeId({ id: item.id }));
    }
    setVisible(vi);
  };

  const handleOpenEdit = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, id: string) => {
    setChanged(!changed);
    handleChangeSearchValue(e, id, false);
    dispatch(changeId({ id }));
  };

  return (
    <div
      className={classNames(styles.item, {
        [styles.visible]: visible,
        [styles.active]: active,
      })}
      onClick={e => handleChangeSearchValue(e, item?.id, true)}
    >
      {
        visible && !disabled
          ? <Rename
            resourceName={item?.name}
            type={RenameType.TYPE_RENAME_DIRECTOR}
            id={item.id || ''}
            visible={true}
            changeVisible={changeVisible}
            callBack={(code, info) => reNameCallback(code, info, item)}
            style={{ width: 185, marginLeft: 2 }}
          />
          : <>
            <div className={styles.name}>{item.name}</div>
            {
              disabled || item?.disableOperate ? null
                : <div className={styles.option}>
                  <span className={styles.edit} onClick={e => handleOpenEdit(e, item.id)}><LibraryEdit /> </span>
                  <Popconfirm
                    content="删除后不可恢复，确定删除吗?"
                    destroyOnClose
                    placement="top"
                    showArrow
                    theme="warning"
                    onConfirm={() => confirmDelete(item.id)}
                  >
                    <span className={styles.delete} ><LibraryDelete /> </span>
                  </Popconfirm>
                </div>
            }
          </>
      }</div>
  );
});

export default LeftPanelItem;
